/* eslint-disable no-console */
import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { useHistory, useParams } from 'react-router-dom';
import { CalloutContext, useOkapiKy } from '@folio/stripes-core';
import useCustomFields from '../../../../../hooks/useCustomFields';
import CategoryForm from './CategoryForm';
import useCustomFieldsCategories from '../../../../../hooks/useCustomFieldsCategories';

const propTypes = {
  basePath: PropTypes.string,
};

const initValues = {
  code: '',
  name: [
    {
      value: '',
      locale: 'ar',
    },
    {
      value: '',
      locale: 'en-US',
    },
  ],
  description: [
    {
      value: '',
      locale: 'ar',
    },
    {
      value: '',
      locale: 'en-US',
    },
  ],
};

function CustomFieldCategoryEdit(props) {
  const history = useHistory();
  const params = useParams();
  const { categories, isLoading } = useCustomFieldsCategories(
    params.categoryId,
  );

  const { locale } = useIntl();
  const context = useContext(CalloutContext);
  const okapiKy = useOkapiKy();

  const [initialValues, setInitialValues] = useState(initValues);

  const localizedName = categories?.label?.find(
    (field) => field?.locale === locale,
  )?.value;

  useEffect(() => {
    if (params.categoryId && categories) {
      setInitialValues(categories);
    } else {
      setInitialValues(initValues);
    }
  }, [categories, params.categoryId]);

  const onAdd = (values) => {
    okapiKy
      .post('customField-category', {
        timeout: 30000,
        method: 'POST',
        json: {
          code: values.code,
          name: values.name,
          description: values.description,
        },
      })
      .json()
      .then((res) => {
        if (res.id) {
          const message = (
            <FormattedMessage
              id="ui-plugin-inventory-templates.customFields.categoryForm.callout.create"
              defaultMessage="Category created successfully"
            />
          );
          history.push(`${props.basePath}/custom-fields-list`);
          context.sendCallout({ message });
        }
      })
      .catch(async (err) => {
        console.log(err);
        const res = err.response;
        const text = await res.text();
        console.log(text);
        context.sendCallout({ message: text, type: 'error' });
      });
  };

  const onEdit = (values) => {
    okapiKy
      .put(`customField-category/${params.categoryId}`, {
        timeout: 30000,
        method: 'PUT',
        headers: {
          'content-Type': 'application/json',
          accept: 'text/plain',
        },
        json: {
          code: values.code,
          name: values.name,
          description: values.description,
        },
      })
      .json()
      .then(() => {
        const message = (
          <FormattedMessage
            id="ui-plugin-inventory-templates.customFields.categoryForm.callout.updated"
            defaultMessage="Category updated successfully."
          />
        );
        history.push(`${props.basePath}/custom-fields-list`);
        context.sendCallout({ message });
      })
      .catch(async (err) => {
        console.log(err);
        const res = err.response;
        const text = await res.text();
        console.log(text);
        context.sendCallout({ message: text, type: 'error' });
      });
  };

  const onSubmit = (values) => {
    if (params.categoryId) {
      onEdit(values);
    } else {
      onAdd(values);
    }
  };

  return (
    <CategoryForm
      categoryId={params.categoryId}
      localizedName={localizedName}
      onClose={() => history.go(-1)}
      onHandleSubmit={onSubmit}
      initialValues={initialValues}
      isLoading={isLoading}
    />
  );
}

CustomFieldCategoryEdit.propTypes = propTypes;

export default CustomFieldCategoryEdit;
